<img
  class="image"
  *ngIf="!lazyOff"
  [width]="width"
  [height]="height"
  [scrollObservable]="eventToObserve"
  [attr.srcset]="srcSet ? srcSet : null"
  [src]="urlDefaultImage"
  [attr.sizes]="sizes ? sizes : null"
  [lazyLoad]="urlImage"
  offset="500"
  [alt]="alt"
  [ngClass]="{'image--cropWidthCentered image-md--noCrop': cropWidthCenteredSm}"
/>
<img
  class="image"
  loading="lazy"
  *ngIf="lazyOff"
  [width]="width"
  [height]="height"
  [attr.srcset]="srcSet ? srcSet : null"
  [src]="urlImage"
  [attr.sizes]="sizes ? sizes : null"
  [alt]="alt"
  [ngClass]="{'image--cropWidthCentered image-md--noCrop': cropWidthCenteredSm}"
/>
<meta itemprop="image" [content]="urlImage" />
